export enum FlowTypes {
  Flow = "Flow",
}
